import {a as a$1}from'./chunk-2FR72HPO.js';import {b}from'./chunk-OPXJCE2V.js';import l,{memo}from'react';import*as o from'@radix-ui/react-popover';import t from'tailwind-styled-components';var i=memo(t(o.Close)`absolute
	top-2
	right-2
	hover:bg-alpha-50
	w-5
	h-5
	rounded-full
	inline-flex
	items-center
	justify-center
	text-primary`),s=memo(t(o.Trigger)`focus:outline-none`),a=memo(t(o.Content)`
relative
bg-white
rounded-md
shadow-lg
border-gray-200
border
`);var v=o.Root;function P(d){return l.createElement(i,b({},d),l.createElement(a$1,{size:"sm",iconName:"xMark",variant:"solid"}))}var e=v;e.Content=a;e.Trigger=s;e.Close=P;var x=e;export{x as a};//# sourceMappingURL=chunk-6NYSN2ON.js.map
//# sourceMappingURL=chunk-6NYSN2ON.js.map